import React from 'react';
import Client from 'App/resources/Model/Client';
import { UnlinkSubaccount } from 'Components/Account/AccountDashboard/SubAccountStateFrame';

const goToAccount = (id: number) => () => {
	Tools.$state.go('account.relations', { id }, { inherit: false });
};

export default function UnlinkSubaccountColumn({
	account,
	createNewAccountRow
}: {
	account: Client;
	createNewAccountRow: boolean;
}) {
	const hasGroupTreeVirtualizedList = Tools.FeatureHelper.hasSoftDeployAccess('GROUP_TREE_VIRTUALIZED_LIST');
	const Component = hasGroupTreeVirtualizedList && !createNewAccountRow ? 'div' : 'td';
	return (
		<Component
			className={`DataSourceColumn unlinkSubaccount ${
				hasGroupTreeVirtualizedList && !createNewAccountRow ? 'align-items-center' : ''
			}`}
		>
			<UnlinkSubaccount
				client={account}
				operationalAccount={account.operationalAccount}
				goToAccount={goToAccount}
			/>
		</Component>
	);
}
